import { dispatchAction } from '@ardoq/rxbeach';

import { closeSidebarPanel } from './actions';
import { SidebarPanelCommands } from './types';

const closePanel = () => dispatchAction(closeSidebarPanel());

export const sidebarPanelCommands: SidebarPanelCommands = {
  closePanel,
};
